<template>
    <!-- 分配子账号弹窗 -->
    <div v-if="userInfo.isShow">
	    <div class="mask allot-child-accont user-center-modal">
	        <div class="e-modal small">
	            <div class="e-modal-title">分配子账号 <i class="e-modal-close" @click="userInfo.isShow=false"></i></div>
	            <div class="e-modal-body">
	                <div class="e-form">
	                    <div class="form-contorl">
	                        <label class="title">姓名：</label>
	                        <input type="text" v-model="Name" />
	                    </div>
	                    <div class="form-contorl">
	                        <label class="title">账号密码：</label>
	                        <input type="password" v-model="Pwd" />
	                    </div>
	                    <div class="form-contorl">
	                        <label class="title">确认密码：</label>
	                        <input type="password" v-model="Pwd2" />
	                    </div>
	                    <div class="form-contorl">
	                        <label class="title">电话：</label>
	                        <input type="text" v-model="Phone" />
	                    </div>
	                    <div class="form-contorl">
	                        <label class="title">传真：</label>
	                        <input type="text" v-model="Fax" />
	                    </div>
	                </div>
	            </div>
	            <div class="e-modal-footer">
	                <div class="long-btn save-btn" @click="create">保存</div>
	                <div class="long-btn cancel-btn" @click="userInfo.isShow=false">取消</div>
	            </div>
	        </div>
	    </div>
	</div>
	
</template>
<script>
	export default{
		name:'AllotChildAccont',
		props:{
			userInfo:{
				type:Object,
				default:function(){
					return{}
				}
			}
		},
		data(){
			return{
				Name:'',
				Pwd:'',
				Pwd2:'',
				Phone:'',
				Fax:''
			}
		},
		methods:{
			create(){
				var that=this;
				if(!that.Name){
		            that.error({title: '创建错误',content: '请输入姓名'})
            		return;
				}
				if(!that.Pwd){
		            that.error({title: '创建错误',content: '请输入账号密码'})
            		return;
				}
				if(that.Pwd.length<6||that.Pwd.length>32){
		            that.error({title: '创建错误',content: '账号密码长度最小6位, 最大 32 位'})
            		return;
				}

				if(!that.Pwd2){
		            that.error({title: '创建错误',content: '请输入确认密码'})
            		return;
				}

				if(that.Pwd!=that.Pwd2){
		            that.error({title: '创建错误',content: '账号密码与确认密码不同'})
            		return;
				}


				if(!that.Phone){
		            that.error({title: '创建错误',content: '请输入电话'})
            		return;
				}
				if(!that.Fax){
		            that.error({title: '创建错误',content: '请输入传真'})
            		return;
				}
				var params={
					Name:this.Name,
					Pwd:this.Pwd,
					Pwd2:this.Pwd2,
					Phone:this.Phone,
					Fax:this.Fax
				}
				that.postRequest({
	                url: that.Api.createSubUser,
	                params: params
	            }).then(res => {
	                if (res&&res.IsSuccess) {
	                	that.error({ title: '提示', content: '创建成功' });
	                	that.userInfo.isShow=false;
	                	that.$emit('done')
	                   
	                } else {
	                    that.error({ title: '提示', content: '创建出错，请重试' });
	                }
	            });

			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/user/AllotChildAccont.vue